import axios from "axios";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import { ArrowLeft } from "@rsuite/icons";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Placeholder } from "rsuite";

import Buttons from "../../buttons/buttons";
import AuthService from "../../../services/auth.service";
import BottomSheet from "../elements/bottom_sheet/BottomSheet";
import MagicProgress from "../elements/magic_progress/magicProgress";

import RefreshIcon from "../../../img/refresh.svg";

import "./physical.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const Physical = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const [bottomSheetConfig, setBottomSheetConfig] = useState({});
  const user = AuthService.getCurrentUser()?.user;
  const isForeign = user?.is_foreign;

  useEffect(() => {
    sync();
  }, []);

  return (
    <div className="physical-container">
      {data ? (
        render()
      ) : (
        <div>
          <Placeholder.Paragraph rows={8} />
          <Loader backdrop content="درحال دریافت وضعیت جسمی ..." vertical />
        </div>
      )}
    </div>
  );

  function render() {
    function bottomSheetHandler(config) {
      setBottomSheetConfig(config);
    }

    return (
      <>
        <div className={`dashboard-banner ${isForeign && "hidden"}`}>
          {data.buttons ? (
            <Buttons
              buttons={data.buttons}
              bottomSheetConfig={bottomSheetConfig}
              bottomSheetHandler={bottomSheetHandler}
            />
          ) : (
            ""
          )}
        </div>
        <div style={{ paddingBottom: "1rem" }}>
          {/* {AuthService.getSubscription() === null && AuthService.getLatestSubscription() !== null  ?
              <div className="expired_subscription_container">
                  <img src={exclemationIcon} style={{height :'1.5rem', margin: '0 0.5rem'}} />
                  <span style={{color:'#F14D62'}}>دوره رژیم شما تمام شده</span>
                  <Button appearance='primary' style={{float:'left', padding: '0.5rem 1rem', position: 'relative', bottom: '0.5rem', left: '0.5rem'}}>
                      تمدید دوره جدید
                  </Button>
              </div>
              : ''
          }  */}
          <div className="d-flex">
            <div
              className="w-50 text-bold text-start"
              style={{ fontSize: "1rem", textAlign: "start" }}
            >
              خلاصه وضعیت شما
            </div>
            <div className="w-50 text-end">
              <button
                onClick={(e) => navigate("/regime-form?type=1")}
                className="reform-btn"
              >
                <img
                  src={RefreshIcon}
                  style={{ height: "1.2em", margin: "0 0.5em" }}
                  alt="refresh-svg"
                />
                محاسبه مجدد
              </button>
            </div>
          </div>
          <div style={{ marginTop: "3rem" }}>
            <MagicProgress
              ranges={data.bmi.ranges}
              max={data.bmi.max}
              currentValue={data.bmi.value}
            />
          </div>

          <div
            className={`message message-${data.bmi.message.type}`}
            style={{
              marginTop: "2rem",
              backgroundColor: data.bmi.message.background_color,
            }}
          >
            <div className="title">{data.bmi.message.title}</div>
            <div className="content">{data.bmi.message.content}</div>
            <div className="image">
              <img
                src={`data:image/svg+xml;utf8,${data.bmi.message.image}`}
                alt=""
              />
            </div>
          </div>

          <div className="target">
            <div className="cards">
              <div className="card-container w-50">
                <div className="card ">
                  <div className="card-title">محدوده وزن سالم</div>
                  <div className="card-value">
                    <span className="text-bold">
                      {data.target.min} - {data.target.max}
                    </span>
                    <span className="text-unit">کیلوگرم</span>
                  </div>
                </div>
              </div>

              <div className="card-container w-50">
                <div className="card ">
                  <div className="card-title">وزن هدف شما</div>
                  <div className="card-value">
                    <span className="text-bold">{data.target.value}</span>
                    <span className="text-unit">کیلوگرم</span>
                  </div>
                </div>
              </div>
              {data.target.diff > 0 && (
                <div className="card-container w-100">
                  <div className="card">
                    <div className="card-title">فاصله شما تا خوش اندامی</div>
                    <div className="card-value">
                      <span className="text-bold">{data.target.diff}</span>
                      <span className="text-unit">کیلوگرم</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="image">
              <img src={data.target.image} alt="" />
            </div>
          </div>

          {data.target.message ? (
            <div className="target-message">
              <div className="title">{data.target.message.title}</div>
              <div className="content">
                {parse(data.target.message.content)}
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="box-footer">
            <Button
              appearance="primary"
              className="btn-get-regime button-footer"
              block
              onClick={(e) => navigate("/subscription-packages")}
            >
              دریافت رژیم مناسب
              {<ArrowLeft />}
            </Button>
          </div>

          <BottomSheet
            bottomSheetConfig={bottomSheetConfig}
            bottomSheetHandler={bottomSheetHandler}
          />
        </div>
      </>
    );
  }

  function sync() {
    if (data || isLoading) {
      return data;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${AuthService.getAccessToken()}`,
        channel: sessionStorage.getItem("channel"),
      },
    };

    const body = {};

    setIsLoading(true);
    axios
      .post(`${APP_URL}/api/v6/health`, body, config)
      .then(function (response) {
        const urlParams = new URLSearchParams(window.location.search);
        if (response.data.action && response.data.action === "intend") {
          toast.loading(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          window.location.replace(
            `${response.data.data}${
              urlParams.get("backUrl")
                ? `?backUrl=${urlParams.get("backUrl")}`
                : ""
            }`
          );
          return true;
        } else if (urlParams.get("backUrl")) {
          navigate(urlParams.get("backUrl"));
        }

        setData(response.data.data);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();

          return false;
        }

        const statusCode = error.response.status;
        switch (statusCode) {
          case 422:
            const { errors } = error.response.data;

            for (const errorsKey in errors) {
              const error = errors[errorsKey];

              toast.error(error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            break;

          case 401:
            AuthService.logout();
            window.location.replace("/");
            break;
          default:
            handleNotfound();

            break;
        }
      });
  }

  function handleNotfound() {
    localStorage.setItem("error", "PageNotFound");
    setIsLoading(false);
    window.location.href = "";
  }
};

export default Physical;
